<template>
	<v-menu
		top
		transition="scroll-x-reverse-transition"
		:value="mostra || $vuetify.breakpoint.lgAndUp"
		@input="(valor) => $emit('input', valor)"
		:close-on-click="false"
		offset-x
	>
		<template #activator="{ on }">
			<v-btn
				fixed
				dark
				fab
				bottom
				left
				small
				:style="$vuetify.breakpoint.mdAndDown
					? { bottom: `${$vuetify.application.bottom + 10}px`, left: '8px' }
					: { bottom: '18px', left: `${$vuetify.application.left + 8}px` }
				"
				color="warning"
				v-on="on"
			>
				<v-icon> mdi-label</v-icon>
			</v-btn>
		</template>
			<v-list
				dense
				class="py-0"
				subheader
				:class="$vuetify.breakpoint.lgAndUp
					? [ 'd-flex']
					: []
				"
			>
				<v-list-item
					class="px-1"
					v-for="legenda in legendas[agenda.tipoDaLabel]"
					:key="legenda.descricao"
				>
					<v-list-item-icon class="mr-1">
						<v-icon :color="legenda.cor"> mdi-square </v-icon>
					</v-list-item-icon>
					<v-list-item-content class="mr-1">
						<v-list-item-title v-text="legenda.descricao" />
					</v-list-item-content>
				</v-list-item>
			</v-list>
	</v-menu>
</template>

<script lang="ts">
export default {
	model: {
		prop: 'mostra',
	},
}
</script>

<script setup lang="ts">
import { agenda } from '@/store'

defineProps({
	mostra: { default: true, type: Boolean },
})

defineEmits<{
	(e: 'input', valor: boolean): void
}>()

const legendas = {
	grau: [
		{
			descricao: 'Grau 1',
			cor: 'green',
		},
		{
			descricao: 'Grau 2',
			cor: 'orange',
		},
		{
			descricao: 'Grau 3',
			cor: 'red',
		},
		{
			descricao: 'Reuniões',
			cor: 'primary',
		},
	],
	tipo: [
		{
			descricao: 'Ordinária',
			cor: 'green',
		},
		{
			descricao: 'Magna',
			cor: 'orange',
		},
		{
			descricao: 'Finanças / Extraordinária',
			cor: 'red',
		},
		{
			descricao: 'Pública',
			cor: 'black',
		},
		{
			descricao: 'Reuniões',
			cor: 'secondary',
		},
	],
}
</script>
